import { Expose } from 'class-transformer'
import type { LoginConfigResponse as Model } from '@/services/api/client'
import type { CamelCaseKeys } from '@/types/utility'

export type SerializedLoginConfigResponse = Model

export default class LoginConfigResponse implements CamelCaseKeys<SerializedLoginConfigResponse> {
    name?: Model['name']

    @Expose({ name: 'tithely_login' })
    tithelyLogin!: Model['tithely_login']

    @Expose({ name: 'tithely_organization_id' })
    tithelyOrganizationId?: Model['tithely_organization_id']

    logo?: Model['logo']

    demo?: Model['demo']

    cancelled?: Model['cancelled']

    @Expose({ name: 'can_create_user' })
    canCreateUser?: Model['can_create_user']

    constructor(values: LoginConfigResponse) {
        Object.assign(this, values)
    }
}
